import { useMutation } from '@tanstack/react-query';
import { submitExtractionSample } from '@/services/extraction-sample.service';
import type { ExtractionSampleRequest, ExtractionSampleResponse } from '@/types/api.types';

/**
 * Extraction Sample Hooks
 * React Query hooks for permit extraction sample API operations (admin only)
 */

/**
 * Hook to submit permit extraction sample
 * Admin endpoint - requires authentication
 */
export const useSubmitExtractionSample = () => {
  return useMutation<ExtractionSampleResponse, Error, ExtractionSampleRequest>({
    mutationFn: submitExtractionSample,
  });
};
